export function* buildDefaultStudyPlanningModalHeightsGenerator(
  trial: boolean,
): Generator<{ mobile: string; tablet: string; desktop: string }, void, unknown> {
  yield { mobile: '350px', tablet: '418px', desktop: '400px' };

  if (!trial) {
    yield { mobile: '570px', tablet: '520px', desktop: '490px' };
  }
}
